import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  ru: { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  en: { code: 'en', label: 'English', flag: '🇺🇸' },
  kk: { code: 'kk', label: 'Қазақша', flag: '🇰🇿' },
};

export const translations = {
  ru: {
    // Navigation
    home: 'Главная',
    dashboard: 'Дашборд',
    trading: 'Трейдинг',
    wallet: 'Кошелёк',
    walletManagement: 'Управление депозитами и выводами',
    qrCodeForDeposit: 'QR-код для депозита',
    scanQrForCopy: 'Отсканируйте QR-код для быстрого копирования адреса',
    withdrawAmount: 'Сумма вывода',
    statusCompleted: 'Выполнен',
    statusRejected: 'Отклонён',
    statusProcessing: 'В обработке',
    profile: 'Профиль',
    portfolio: 'Профиль',
    ido: 'IDO Launchpad',
    idoLaunchpad: 'IDO Launchpad',
    support: 'Поддержка',
    security: 'Безопасность',
    adminPanel: 'Админ панель',
    
    // Profile & Settings
    editProfile: 'Редактировать профиль',
    name: 'Имя',
    phone: 'Телефон',
    email: 'Email',
    save: 'Сохранить',
    cancel: 'Отмена',
    viewAll: 'Все →',
    notifications: 'Уведомления',
    logout: 'Выйти',
    settings: 'Настройки',
    theme: 'Тема',
    language: 'Язык',
    darkTheme: 'Тёмная',
    lightTheme: 'Светлая',
    
    // Wallet & Balance
    exchangeBalance: 'Баланс биржи',
    totalBalance: 'Общий баланс',
    totalPortfolioBalance: 'Общий баланс портфеля',
    available: 'Доступно',
    inPositions: 'В позициях',
    idoTokens: 'IDO Токены',
    connectedWallets: 'Подключённые кошельки',
    connectWallet: 'Подключить кошелёк',
    walletConnectDescMobile: 'Нажмите кнопку ниже, чтобы подключить кошелёк',
    walletConnectDescDesktop: 'Отсканируйте QR-код камерой вашего мобильного кошелька',
    addAnotherWallet: 'Добавить ещё кошелёк',
    connectWithQR: 'Подключить через QR',
    walletConnectHelp: 'Поддерживается 300+ кошельков через WalletConnect',
    connecting: 'Подключение...',
    disconnect: 'Отключить',
    noWallets: 'Нет подключённых кошельков',
    walletNotConnected: 'Не подключён',
    deposit: 'Депозит',
    withdraw: 'Вывод',
    
    // Trading & Stats
    winRate: 'Винрейт',
    trades: 'Сделок',
    totalTrades: 'Всего сделок',
    profitable: 'Прибыльных',
    losing: 'Убыточных',
    open: 'Открытых',
    closed: 'Закрытых',
    tradingStats: 'Статистика трейдинга',
    portfolioDynamics: 'Динамика портфеля',
    
    // Home Page
    portfolioOverview: 'Обзор портфеля',
    welcome: 'Добро пожаловать',
    refresh: 'Обновить',
    viewAll: 'Все',
    newIdoAvailable: 'Новое IDO доступно',
    highVolatility: 'Высокая волатильность',
    transactionConfirmed: 'Транзакция подтверждена',
    yourDepositSuccess: 'Ваш депозит успешно зачислен',
    btcSharpMovements: 'BTC показывает резкие движения',
    totalPortfolioBalance: 'Общий баланс портфеля',
    available: 'Доступно',
    spotBalance: 'Спот баланс',
    idoBalance: 'IDO баланс',
    inPositions: 'В позициях',
    realizedPnl: 'Реализованный PnL',
    portfolioDistribution: 'Распределение портфеля',
    spotAssets: 'Спот активы',
    idoTokens: 'IDO токены',
    spotAssetsTitle: 'СПОТОВЫЕ АКТИВЫ',
    idoAssetsTitle: 'IDO АКТИВЫ',
    trade: 'Торговать',
    marketCap: 'Рыночная капитализация',
    volume24h: '24ч Объём',
    btcDominance: 'BTC Доминация',
    gainers: 'Рост',
    losers: 'Падение',
    
    // Time
    hoursAgo: 'ч назад',
    daysAgo: 'д назад',
    minutesAgo: 'мин назад',
    
    // Asset Distribution
    assetDistribution: 'Распределение активов',
    availableUsdt: 'Доступно USDT',
    spotPositions: 'Spot Позиции',
    inFutures: 'В Фьючерсах',
    maxDrawdown: 'Макс. просадка',
    bestTrade: 'Лучшая сделка',
    recentActivity: 'Недавняя активность',
    positionOpened: 'Открыта позиция',
    depositMade: 'Пополнение',
    idoBought: 'Куплен IDO',
    balance: 'Баланс',
    
    // Common Actions
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',
    confirm: 'Подтвердить',
    copy: 'Копировать',
    copied: 'Скопировано',
    search: 'Поиск',
    filter: 'Фильтр',
    noDataAvailable: 'Нет данных',
    apply: 'Применить',
    reset: 'Сбросить',
    close: 'Закрыть',
    closePosition: 'Закрыть позицию?',
    closing: 'Закрытие...',
    back: 'Назад',
    next: 'Далее',
    submit: 'Отправить',
    
    // Support
    supportTickets: 'Тикеты поддержки',
    createTicket: 'Создать тикет',
    subject: 'Тема',
    message: 'Сообщение',
    status: 'Статус',
    
    // Security Page
    changePassword: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    twoFactorAuth: 'Двухфакторная аутентификация',
    accountProtected: 'Аккаунт защищён',
    accountNotProtected: 'Аккаунт не защищён',
    twoFAEnabled: '2FA включена',
    enable2FAForProtection: 'Включите 2FA для защиты',
    enable2FA: 'Включить 2FA',
    on: 'Вкл',
    off: 'Выкл',
    securityTips: 'Советы по безопасности',
    securityTip1: 'Используйте уникальный пароль для ExDex',
    securityTip2: 'Включите 2FA для максимальной защиты',
    securityTip3: 'Никогда не делитесь своими данными для входа',
    securityTip4: 'Регулярно проверяйте активные сессии',
    disable2FA: 'Отключить 2FA',
    activeSessions: 'Активные сессии',
    terminateSession: 'Завершить сессию',
    terminateAll: 'Завершить все',
    ipWhitelist: 'Белый список IP',
    twoFAAuthenticator: 'Аутентификатор',
    twoFAEmail: 'Email',
    twoFABoth: 'Оба метода',
    enabled: 'Включено',
    disabled: 'Отключено',
    ipAddress: 'IP адрес',
    
    // Deposits & Withdrawals
    deposit: 'Депозит',
    withdraw: 'Вывод',
    history: 'История',
    availableBalance: 'Доступный баланс',
    currency: 'Валюта',
    amount: 'Сумма',
    withdrawalAddress: 'Адрес вывода',
    enterAmount: 'Введите сумму',
    enterAddress: 'Введите адрес',
    quickAmount: 'Быстрый выбор суммы',
    submitWithdrawal: 'Отправить заявку',
    processing: 'Обработка...',
    yourDeposits: 'Ваши депозиты',
    yourWithdrawals: 'Ваши выводы',
    noDeposits: 'Нет депозитов',
    noWithdrawals: 'Нет выводов',
    depositMethod: 'Способ депозита',
    directDeposit: 'Прямой депозит',
    manualDeposit: 'Ручной депозит',
    connectWallet: 'Подключить кошелёк',
    walletConnected: 'Кошелёк подключен',
    walletBalance: 'Баланс кошелька',
    sendFromWallet: 'Отправить из кошелька',
    sending: 'Отправка...',
    txHash: 'Хеш транзакции',
    optional: 'необязательно',
    submitDeposit: 'Отправить депозит',
    copyAddress: 'Скопировать адрес',
    addressCopied: 'Адрес скопирован',
    minDeposit: 'Мин. депозит',
    maxDeposit: 'Макс. депозит',
    fee: 'Комиссия',
    network: 'Сеть',
    status: 'Статус',
    date: 'Дата',
    approved: 'Одобрено',
    warning: 'Внимание',
    warningWithdrawal: 'Проверьте адрес вывода. Транзакции необратимы.',
    exchangeDescription: 'Децентрализованная криптобиржа',
    withdrawDescription: 'Вывод средств с биржи',
    
    // Wallet Page
    depositAddress: 'Адрес для депозита',
    selectNetwork: 'Выберите сеть',
    scanQr: 'Сканируйте QR-код',
    orCopyAddress: 'или скопируйте адрес',
    withdrawalHistory: 'История выводов',
    depositHistory: 'История депозитов',
    pending: 'Ожидание',
    completed: 'Завершено',
    failed: 'Ошибка',
    
    // Trading Page
    buy: 'Купить',
    sell: 'Продать',
    market: 'Рыночный',
    limit: 'Лимитный',
    quantity: 'Количество',
    price: 'Цена',
    total: 'Итого',
    openOrders: 'Открытые ордера',
    orderHistory: 'История ордеров',
    positions: 'Позиции',
    orders: 'Ордера',
    futures: 'Фьючерсы',
    spot: 'Спот',
    recentTrades: 'Последние сделки',
    indicators: 'Индикаторы',
    symbol: 'Символ',
    size: 'Размер',
    entry: 'Вход',
    liq: 'Ликв.',
    actions: 'Действия',
    openPosition: 'Открыть',
    
    // IDO Page
    participate: 'Участвовать',
    allocation: 'Аллокация',
    tokenPrice: 'Цена токена',
    hardCap: 'Hard Cap',
    softCap: 'Soft Cap',
    startDate: 'Начало',
    endDate: 'Окончание',
    participants: 'Участников',
    raised: 'Собрано',
    remaining: 'Осталось',
    progress: 'Прогресс',
    buyButton: 'Купить',
    sellButton: 'Продать',
    openForBuy: 'Открыты для покупки',
    openForSell: 'Открыты для продажи',
    yourBalance: 'Ваш баланс',
    tokens: 'токенов',
    sold: 'Продано',
    total: 'Всего',
    minPurchase: 'Мин. покупка',
    maxPurchase: 'Макс. покупка',
    buyPrice: 'Цена покупки',
    sellPrice: 'Цена продажи',
    insufficientTokens: 'Недостаточно токенов',
    idoPortfolio: 'Портфель IDO',
    boughtAt: 'Куплено по',
    purchase: 'Покупка',
    sale: 'Продажа',
    
    // Home Page Extra
    popularMarkets: 'Популярные рынки',
    openPositions: 'Открытые позиции',
    management: 'Управление',
    all: 'Все',
    noOpenPositions: 'Нет открытых позиций',
    startTrading: 'Начать торговлю',
    myIdoTokens: 'Мои IDO Токены',
    spotPortfolio: 'Spot Портфолио',
    topMarkets: 'Топ рынков',
    growth: 'Рост',
    decline: 'Падение',
    margin: 'Маржа',
    connectedWalletLabel: 'Подключённый кошелёк',
    savedWallet: 'Сохранённый кошелёк',
    walletNeedsReconnect: 'Требуется переподключение для транзакций',
    reconnect: 'Переподключить',
    add: 'Добавить',
    deposits: 'Депозиты',
    withdrawals: 'Выводы',
    noWithdrawalsYet: 'Нет выводов',
    noDepositsYet: 'Нет депозитов',
    withdrawFunds: 'Вывести средства',
    availableForWithdrawal: 'Доступно для вывода',
    withdrawalInfo: 'Информация о выводе',
    networkFee: 'Комиссия сети',
    minWithdrawal: 'Мин. вывод',
    processingTime: 'Время обработки',
    hours: 'часа',
    walletAddress: 'Адрес кошелька',
    enterWalletAddress: 'Введите адрес кошелька',
    checkAddress: 'Проверьте адрес получателя. Транзакции необратимы.',
    sendingInProgress: 'Отправка...',
    processingInProgress: 'Обработка...',
    confirmDeposit: 'Подтвердить депозит',
    sendFromWalletButton: 'Отправить с кошелька',
    availableInWallet: 'Доступно в кошельке',
    notConfigured: 'Не настроен',
    
    // Errors & Validation
    requiredField: 'Обязательное поле',
    invalidEmail: 'Некорректный email',
    passwordTooShort: 'Пароль слишком короткий',
    passwordsNotMatch: 'Пароли не совпадают',
    insufficientBalance: 'Недостаточно средств',
    passwordNotMeetRequirements: 'Пароль не соответствует требованиям',
    pleaseAgreeToTerms: 'Пожалуйста, примите условия использования',
    comingSoon: 'Скоро будет доступно',
    registrationComingSoon: 'Регистрация через {provider} — скоро!',
    failedToConnectWallet: 'Не удалось подключить кошелёк',
    connectWalletFirst: 'Сначала подключите кошелёк',
    depositAddressNotConfigured: 'Адрес депозита не настроен',
    enterValidAmount: 'Введите корректную сумму',
    insufficientWalletBalance: 'Недостаточно средств на кошельке',
    transactionCancelled: 'Транзакция отменена',
    transactionFailed: 'Ошибка транзакции',
    sentSuccessfully: 'Успешно отправлено',
    depositRequestCreated: 'Заявка на депозит создана',
    failedToCreateDeposit: 'Не удалось создать депозит',
    withdrawalRequestCreated: 'Заявка на вывод создана',
    failedToCreateWithdrawal: 'Не удалось создать вывод',
    errorPrefix: 'Ошибка',
    enterWithdrawalAddress: 'Введите адрес для вывода',
    
    // Login/Register
    login: 'Вход',
    register: 'Регистрация',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    haveAccount: 'Уже есть аккаунт?',
    signUp: 'Зарегистрироваться',
    signIn: 'Войти',
    welcomeBack: 'С возвращением',
    signInToContinue: 'Войдите в аккаунт для продолжения',
    emailAddress: 'Email адрес',
    enterEmail: 'Введите email',
    password: 'Пароль',
    enterPassword: 'Введите пароль',
    orContinueWith: 'Или продолжить с',
    termsAgreement: 'Продолжая, вы соглашаетесь с Условиями использования и Политикой конфиденциальности ExDex',
    createAccount: 'Создать аккаунт',
    startJourney: 'Начните своё крипто-путешествие',
    confirmYourPassword: 'Подтвердите пароль',
    passwordRequirements: 'Требования к паролю',
    minChars: 'Минимум 6 символов',
    hasNumber: 'Содержит цифру',
    hasLetter: 'Содержит букву',
    agreeToTerms: 'Я согласен с',
    termsOfService: 'Условиями использования',
    and: 'и',
    privacyPolicy: 'Политикой конфиденциальности',
    twoFactorAuth: 'Двухфакторная аутентификация',
    enterAuthenticatorCode: 'Введите код из Google Authenticator',
    enterEmailCode: 'Введите код, отправленный на email',
    enterBothCodes: 'Введите оба кода для подтверждения',
    verifying: 'Проверка...',
    invalidCode: 'Неверный код',
    sendCode: 'Отправить код',
    codeSent: 'Код отправлен',
    authenticatorCode: 'Код аутентификатора',
    emailVerificationCode: 'Код из email',
  },
  
  en: {
    // Navigation
    home: 'Home',
    dashboard: 'Dashboard',
    trading: 'Trading',
    wallet: 'Wallet',
    walletManagement: 'Manage deposits and withdrawals',
    qrCodeForDeposit: 'QR Code for Deposit',
    scanQrForCopy: 'Scan QR code for quick address copy',
    withdrawAmount: 'Withdrawal Amount',
    statusCompleted: 'Completed',
    statusRejected: 'Rejected',
    statusProcessing: 'Processing',
    profile: 'Profile',
    portfolio: 'Portfolio',
    ido: 'IDO Launchpad',
    idoLaunchpad: 'IDO Launchpad',
    support: 'Support',
    security: 'Security',
    adminPanel: 'Admin Panel',
    
    // Profile & Settings
    editProfile: 'Edit Profile',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    save: 'Save',
    cancel: 'Cancel',
    viewAll: 'View All →',
    notifications: 'Notifications',
    logout: 'Logout',
    settings: 'Settings',
    theme: 'Theme',
    language: 'Language',
    darkTheme: 'Dark',
    lightTheme: 'Light',
    
    // Wallet & Balance
    exchangeBalance: 'Exchange Balance',
    totalBalance: 'Total Balance',
    totalPortfolioBalance: 'Total Portfolio Balance',
    available: 'Available',
    inPositions: 'In Positions',
    idoTokens: 'IDO Tokens',
    connectedWallets: 'Connected Wallets',
    connectWallet: 'Connect Wallet',
    walletConnectDescMobile: 'Tap the button below to connect your wallet',
    walletConnectDescDesktop: 'Scan QR code with your mobile wallet camera',
    addAnotherWallet: 'Add Another Wallet',
    connectWithQR: 'Connect with QR',
    walletConnectHelp: 'Supports 300+ wallets via WalletConnect',
    connecting: 'Connecting...',
    disconnect: 'Disconnect',
    noWallets: 'No connected wallets',
    walletNotConnected: 'Not Connected',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    
    // Deposits & Withdrawals
    history: 'History',
    availableBalance: 'Available Balance',
    currency: 'Currency',
    amount: 'Amount',
    withdrawalAddress: 'Withdrawal Address',
    enterAmount: 'Enter amount',
    enterAddress: 'Enter address',
    quickAmount: 'Quick Amount',
    submitWithdrawal: 'Submit Withdrawal',
    processing: 'Processing...',
    yourDeposits: 'Your Deposits',
    yourWithdrawals: 'Your Withdrawals',
    noDeposits: 'No deposits yet',
    noWithdrawals: 'No withdrawals yet',
    depositMethod: 'Deposit Method',
    directDeposit: 'Direct Deposit',
    manualDeposit: 'Manual Deposit',
    connectWallet: 'Connect Wallet',
    walletConnected: 'Wallet Connected',
    walletBalance: 'Wallet Balance',
    sendFromWallet: 'Send from Wallet',
    sending: 'Sending...',
    txHash: 'Transaction Hash',
    optional: 'optional',
    submitDeposit: 'Submit Deposit',
    copyAddress: 'Copy Address',
    addressCopied: 'Address Copied',
    minDeposit: 'Min Deposit',
    maxDeposit: 'Max Deposit',
    fee: 'Fee',
    network: 'Network',
    status: 'Status',
    date: 'Date',
    approved: 'Approved',
    warning: 'Warning',
    warningWithdrawal: 'Double-check the withdrawal address. Transactions are irreversible.',
    exchangeDescription: 'Decentralized Cryptocurrency Exchange',
    withdrawDescription: 'Withdraw funds from your exchange balance',
    
    // Asset Distribution
    assetDistribution: 'Asset Distribution',
    availableUsdt: 'Available USDT',
    spotPositions: 'Spot Positions',
    inFutures: 'In Futures',
    maxDrawdown: 'Max Drawdown',
    bestTrade: 'Best Trade',
    recentActivity: 'Recent Activity',
    positionOpened: 'Position Opened',
    depositMade: 'Deposit Made',
    idoBought: 'IDO Bought',
    balance: 'Balance',
    
    // Trading & Stats
    winRate: 'Win Rate',
    trades: 'Trades',
    totalTrades: 'Total Trades',
    profitable: 'Profitable',
    losing: 'Losing',
    open: 'Open',
    closed: 'Closed',
    tradingStats: 'Trading Stats',
    portfolioDynamics: 'Portfolio Dynamics',
    
    // Home Page
    portfolioOverview: 'Portfolio Overview',
    welcome: 'Welcome',
    refresh: 'Refresh',
    viewAll: 'All',
    newIdoAvailable: 'New IDO Available',
    highVolatility: 'High Volatility',
    transactionConfirmed: 'Transaction Confirmed',
    yourDepositSuccess: 'Your deposit was successful',
    btcSharpMovements: 'BTC showing sharp movements',
    totalPortfolioBalance: 'Total Portfolio Balance',
    available: 'Available',
    spotBalance: 'Spot Balance',
    idoBalance: 'IDO Balance',
    inPositions: 'In Positions',
    realizedPnl: 'Realized PnL',
    portfolioDistribution: 'Portfolio Distribution',
    spotAssets: 'Spot Assets',
    idoTokens: 'IDO Tokens',
    spotAssetsTitle: 'SPOT ASSETS',
    idoAssetsTitle: 'IDO ASSETS',
    trade: 'Trade',
    marketCap: 'Market Cap',
    volume24h: '24h Volume',
    btcDominance: 'BTC Dominance',
    gainers: 'Gainers',
    losers: 'Losers',
    
    // Time
    hoursAgo: 'h ago',
    daysAgo: 'd ago',
    minutesAgo: 'min ago',
    
    // Common Actions
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    copy: 'Copy',
    copied: 'Copied',
    search: 'Search',
    filter: 'Filter',
    noDataAvailable: 'No data available',
    apply: 'Apply',
    reset: 'Reset',
    close: 'Close',
    closePosition: 'Close position?',
    closing: 'Closing...',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    
    // Support
    supportTickets: 'Support Tickets',
    createTicket: 'Create Ticket',
    subject: 'Subject',
    message: 'Message',
    status: 'Status',
    
    // Security Page
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    twoFactorAuth: 'Two-Factor Authentication',
    accountProtected: 'Account Protected',
    accountNotProtected: 'Account Not Protected',
    twoFAEnabled: '2FA Enabled',
    enable2FAForProtection: 'Enable 2FA for protection',
    enable2FA: 'Enable 2FA',
    on: 'On',
    off: 'Off',
    securityTips: 'Security Tips',
    securityTip1: 'Use a unique password for ExDex',
    securityTip2: 'Enable 2FA for maximum protection',
    securityTip3: 'Never share your login credentials',
    securityTip4: 'Regularly check active sessions',
    disable2FA: 'Disable 2FA',
    activeSessions: 'Active Sessions',
    terminateSession: 'Terminate Session',
    terminateAll: 'Terminate All',
    ipWhitelist: 'IP Whitelist',
    twoFAAuthenticator: 'Authenticator',
    twoFAEmail: 'Email',
    twoFABoth: 'Both Methods',
    enabled: 'Enabled',
    disabled: 'Disabled',
    ipAddress: 'IP Address',
    
    // Wallet Page
    depositAddress: 'Deposit Address',
    selectNetwork: 'Select Network',
    scanQr: 'Scan QR Code',
    orCopyAddress: 'or copy address',
    withdrawalHistory: 'Withdrawal History',
    depositHistory: 'Deposit History',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    
    // Trading Page
    buy: 'Buy',
    sell: 'Sell',
    market: 'Market',
    limit: 'Limit',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
    openOrders: 'Open Orders',
    orderHistory: 'Order History',
    positions: 'Positions',
    orders: 'Orders',
    futures: 'Futures',
    spot: 'Spot',
    recentTrades: 'Recent Trades',
    indicators: 'Indicators',
    symbol: 'Symbol',
    size: 'Size',
    entry: 'Entry',
    liq: 'Liq.',
    actions: 'Actions',
    openPosition: 'Open',
    
    // IDO Page
    participate: 'Participate',
    allocation: 'Allocation',
    tokenPrice: 'Token Price',
    hardCap: 'Hard Cap',
    softCap: 'Soft Cap',
    startDate: 'Start Date',
    endDate: 'End Date',
    participants: 'Participants',
    raised: 'Raised',
    remaining: 'Remaining',
    progress: 'Progress',
    buyButton: 'Buy',
    sellButton: 'Sell',
    openForBuy: 'Open for Purchase',
    openForSell: 'Open for Sale',
    yourBalance: 'Your Balance',
    tokens: 'tokens',
    sold: 'Sold',
    total: 'Total',
    minPurchase: 'Min Purchase',
    maxPurchase: 'Max Purchase',
    buyPrice: 'Buy Price',
    sellPrice: 'Sell Price',
    insufficientTokens: 'Insufficient tokens',
    idoPortfolio: 'IDO Portfolio',
    boughtAt: 'Bought at',
    purchase: 'Purchase',
    sale: 'Sale',
    
    // Home Page Extra
    popularMarkets: 'Popular Markets',
    openPositions: 'Open Positions',
    management: 'Manage',
    all: 'All',
    noOpenPositions: 'No open positions',
    startTrading: 'Start Trading',
    myIdoTokens: 'My IDO Tokens',
    spotPortfolio: 'Spot Portfolio',
    topMarkets: 'Top Markets',
    growth: 'Growth',
    decline: 'Decline',
    margin: 'Margin',
    connectedWalletLabel: 'Connected Wallet',
    savedWallet: 'Saved Wallet',
    walletNeedsReconnect: 'Reconnection required for transactions',
    reconnect: 'Reconnect',
    add: 'Add',
    deposits: 'Deposits',
    withdrawals: 'Withdrawals',
    noWithdrawalsYet: 'No withdrawals',
    noDepositsYet: 'No deposits',
    withdrawFunds: 'Withdraw Funds',
    availableForWithdrawal: 'Available for Withdrawal',
    withdrawalInfo: 'Withdrawal Info',
    networkFee: 'Network Fee',
    minWithdrawal: 'Min Withdrawal',
    processingTime: 'Processing Time',
    hours: 'hours',
    walletAddress: 'Wallet Address',
    enterWalletAddress: 'Enter wallet address',
    checkAddress: 'Double-check the recipient address. Transactions are irreversible.',
    sendingInProgress: 'Sending...',
    processingInProgress: 'Processing...',
    confirmDeposit: 'Confirm Deposit',
    sendFromWalletButton: 'Send from Wallet',
    availableInWallet: 'Available in wallet',
    notConfigured: 'Not configured',
    
    // Errors & Validation
    requiredField: 'Required field',
    invalidEmail: 'Invalid email',
    passwordTooShort: 'Password too short',
    passwordsNotMatch: 'Passwords do not match',
    insufficientBalance: 'Insufficient balance',
    passwordNotMeetRequirements: 'Password does not meet requirements',
    pleaseAgreeToTerms: 'Please agree to the Terms of Service',
    comingSoon: 'Coming Soon',
    registrationComingSoon: '{provider} registration — Coming Soon!',
    failedToConnectWallet: 'Failed to connect wallet',
    connectWalletFirst: 'Please connect your wallet first',
    depositAddressNotConfigured: 'Deposit address not configured',
    enterValidAmount: 'Please enter a valid amount',
    insufficientWalletBalance: 'Insufficient wallet balance',
    transactionCancelled: 'Transaction cancelled',
    transactionFailed: 'Transaction failed',
    sentSuccessfully: 'Sent successfully',
    depositRequestCreated: 'Deposit request created',
    failedToCreateDeposit: 'Failed to create deposit',
    withdrawalRequestCreated: 'Withdrawal request created',
    failedToCreateWithdrawal: 'Failed to create withdrawal',
    errorPrefix: 'Error',
    enterWithdrawalAddress: 'Please enter withdrawal address',
    
    // Login/Register
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password?',
    noAccount: 'No account?',
    haveAccount: 'Have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to your account to continue',
    emailAddress: 'Email Address',
    enterEmail: 'Enter your email',
    password: 'Password',
    enterPassword: 'Enter your password',
    orContinueWith: 'Or continue with',
    termsAgreement: 'By continuing, you agree to ExDex\'s Terms of Service and Privacy Policy',
    createAccount: 'Create Account',
    startJourney: 'Start your crypto journey today',
    confirmYourPassword: 'Confirm Password',
    passwordRequirements: 'Password Requirements',
    minChars: 'At least 6 characters',
    hasNumber: 'Contains a number',
    hasLetter: 'Contains a letter',
    agreeToTerms: 'I agree to',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    twoFactorAuth: 'Two-Factor Authentication',
    enterAuthenticatorCode: 'Enter code from Google Authenticator',
    enterEmailCode: 'Enter code sent to your email',
    enterBothCodes: 'Enter both codes for verification',
    verifying: 'Verifying...',
    invalidCode: 'Invalid code',
    sendCode: 'Send Code',
    codeSent: 'Code Sent',
    authenticatorCode: 'Authenticator Code',
    emailVerificationCode: 'Email Verification Code',
  },
  
  kk: {
    // Navigation
    home: 'Басты бет',
    dashboard: 'Дашборд',
    trading: 'Сауда',
    wallet: 'Әмиян',
    walletManagement: 'Депозиттер мен шығаруларды басқару',
    qrCodeForDeposit: 'Депозит үшін QR-код',
    scanQrForCopy: 'Мекенжайды жылдам көшіру үшін QR-кодты сканерлеңіз',
    withdrawAmount: 'Шығару сомасы',
    statusCompleted: 'Аяқталды',
    statusRejected: 'Қабылданбады',
    statusProcessing: 'Өңделуде',
    profile: 'Профиль',
    portfolio: 'Профиль',
    ido: 'IDO Launchpad',
    idoLaunchpad: 'IDO Launchpad',
    support: 'Қолдау',
    security: 'Қауіпсіздік',
    adminPanel: 'Админ панелі',
    
    // Profile & Settings
    editProfile: 'Профильді өзгерту',
    name: 'Аты',
    phone: 'Телефон',
    email: 'Email',
    save: 'Сақтау',
    cancel: 'Болдырмау',
    viewAll: 'Барлығы →',
    notifications: 'Хабарландырулар',
    logout: 'Шығу',
    settings: 'Параметрлер',
    theme: 'Тема',
    language: 'Тіл',
    darkTheme: 'Қараңғы',
    lightTheme: 'Жарық',
    
    // Wallet & Balance
    exchangeBalance: 'Биржа балансы',
    totalBalance: 'Жалпы баланс',
    totalPortfolioBalance: 'Портфолио балансы',
    available: 'Қолжетімді',
    inPositions: 'Позицияларда',
    idoTokens: 'IDO Токендер',
    connectedWallets: 'Қосылған әмияндар',
    connectWallet: 'Әмиян қосу',
    disconnect: 'Ажырату',
    noWallets: 'Қосылған әмияндар жоқ',
    walletNotConnected: 'Қосылмаған',
    deposit: 'Депозит',
    withdraw: 'Шығару',
    
    // Deposits & Withdrawals
    history: 'Тарих',
    availableBalance: 'Қолжетімді баланс',
    currency: 'Валюта',
    amount: 'Сома',
    withdrawalAddress: 'Шығару мекенжайы',
    enterAmount: 'Соманы енгізіңіз',
    enterAddress: 'Мекенжайды енгізіңіз',
    quickAmount: 'Жылдам таңдау',
    submitWithdrawal: 'Өтінімді жіберу',
    processing: 'Өңделуде...',
    yourDeposits: 'Сіздің депозиттеріңіз',
    yourWithdrawals: 'Сіздің шығаруларыңыз',
    noDeposits: 'Депозиттер жоқ',
    noWithdrawals: 'Шығарулар жоқ',
    depositMethod: 'Депозит әдісі',
    directDeposit: 'Тікелей депозит',
    manualDeposit: 'Қолмен депозит',
    walletConnected: 'Әмиян қосылды',
    walletBalance: 'Әмиян балансы',
    sendFromWallet: 'Әмияннан жіберу',
    sending: 'Жіберілуде...',
    txHash: 'Транзакция хэші',
    optional: 'міндетті емес',
    submitDeposit: 'Депозитті жіберу',
    copyAddress: 'Мекенжайды көшіру',
    addressCopied: 'Мекенжай көшірілді',
    minDeposit: 'Мин. депозит',
    maxDeposit: 'Макс. депозит',
    fee: 'Комиссия',
    network: 'Желі',
    status: 'Мәртебе',
    date: 'Күні',
    approved: 'Мақұлданды',
    warning: 'Ескерту',
    warningWithdrawal: 'Шығару мекенжайын тексеріңіз. Транзакциялар қайтарылмайды.',
    exchangeDescription: 'Орталықсыздандырылған криптобиржа',
    withdrawDescription: 'Биржадан қаражат шығару',
    
    // Asset Distribution
    assetDistribution: 'Активтерді бөлу',
    availableUsdt: 'Қолжетімді USDT',
    spotPositions: 'Spot Позициялар',
    inFutures: 'Фьючерстерде',
    maxDrawdown: 'Макс. төмендеу',
    bestTrade: 'Ең жақсы мәміле',
    recentActivity: 'Соңғы белсенділік',
    positionOpened: 'Позиция ашылды',
    depositMade: 'Толтыру',
    idoBought: 'IDO сатып алынды',
    balance: 'Баланс',
    
    // Trading & Stats
    winRate: 'Жеңіс пайызы',
    trades: 'Мәмілелер',
    totalTrades: 'Барлық мәмілелер',
    profitable: 'Табысты',
    losing: 'Шығынды',
    open: 'Ашық',
    closed: 'Жабық',
    tradingStats: 'Сауда статистикасы',
    portfolioDynamics: 'Портфолио динамикасы',
    
    // Home Page
    portfolioOverview: 'Портфолио шолуы',
    welcome: 'Қош келдіңіз',
    refresh: 'Жаңарту',
    viewAll: 'Барлығы',
    newIdoAvailable: 'Жаңа IDO қол жетімді',
    highVolatility: 'Жоғары құбылмалылық',
    transactionConfirmed: 'Транзакция расталды',
    yourDepositSuccess: 'Сіздің депозитіңіз сәтті өтті',
    btcSharpMovements: 'BTC қатты қозғалыстар көрсетуде',
    totalPortfolioBalance: 'Жалпы портфолио балансы',
    available: 'Қолжетімді',
    spotBalance: 'Спот балансы',
    idoBalance: 'IDO балансы',
    inPositions: 'Позицияларда',
    realizedPnl: 'Іске асырылған PnL',
    portfolioDistribution: 'Портфолио бөлінісі',
    spotAssets: 'Спот активтер',
    idoTokens: 'IDO токендері',
    spotAssetsTitle: 'СПОТ АКТИВТЕР',
    idoAssetsTitle: 'IDO АКТИВТЕРІ',
    trade: 'Сауда',
    marketCap: 'Нарық капитализациясы',
    volume24h: '24с Көлем',
    btcDominance: 'BTC үстемдігі',
    gainers: 'Өсу',
    losers: 'Төмендеу',
    
    // Time
    hoursAgo: 'сағ бұрын',
    daysAgo: 'күн бұрын',
    minutesAgo: 'мин бұрын',
    
    // Common Actions
    loading: 'Жүктелуде...',
    error: 'Қате',
    success: 'Сәтті',
    confirm: 'Растау',
    copy: 'Көшіру',
    copied: 'Көшірілді',
    search: 'Іздеу',
    filter: 'Сүзгі',
    noDataAvailable: 'Деректер жоқ',
    apply: 'Қолдану',
    reset: 'Тазалау',
    close: 'Жабу',
    closePosition: 'Позицияны жабу?',
    closing: 'Жабылуда...',
    back: 'Артқа',
    next: 'Келесі',
    submit: 'Жіберу',
    
    // Support
    supportTickets: 'Қолдау тикеттері',
    createTicket: 'Тикет жасау',
    subject: 'Тақырып',
    message: 'Хабарлама',
    status: 'Күй',
    
    // Security Page
    changePassword: 'Құпия сөзді өзгерту',
    currentPassword: 'Ағымдағы құпия сөз',
    newPassword: 'Жаңа құпия сөз',
    confirmPassword: 'Құпия сөзді растаңыз',
    twoFactorAuth: 'Екі факторлы аутентификация',
    accountProtected: 'Аккаунт қорғалған',
    accountNotProtected: 'Аккаунт қорғалмаған',
    twoFAEnabled: '2FA қосылған',
    enable2FAForProtection: 'Қорғаныс үшін 2FA қосыңыз',
    enable2FA: '2FA қосу',
    on: 'Қосу',
    off: 'Өшір',
    securityTips: 'Қауіпсіздік кеңестері',
    securityTip1: 'ExDex үшін бірегей құпия сөз қолданыңыз',
    securityTip2: 'Максималды қорғаныс үшін 2FA қосыңыз',
    securityTip3: 'Кіру деректеріңізбен ешкіммен бөліспеңіз',
    securityTip4: 'Белсенді сессияларды үнемі тексеріңіз',
    disable2FA: '2FA өшіру',
    activeSessions: 'Белсенді сессиялар',
    terminateSession: 'Сессияны аяқтау',
    terminateAll: 'Барлығын аяқтау',
    ipWhitelist: 'IP ақ тізімі',
    twoFAAuthenticator: 'Аутентификатор',
    twoFAEmail: 'Email',
    twoFABoth: 'Екі әдіс те',
    enabled: 'Қосылған',
    disabled: 'Өшірілген',
    ipAddress: 'IP мекенжайы',
    
    // Wallet Page
    depositAddress: 'Депозит адресі',
    selectNetwork: 'Желіні таңдаңыз',
    scanQr: 'QR кодын сканерлеңіз',
    orCopyAddress: 'немесе адресті көшіріңіз',
    withdrawalHistory: 'Шығару тарихы',
    depositHistory: 'Депозит тарихы',
    pending: 'Күтуде',
    completed: 'Аяқталды',
    failed: 'Қате',
    
    // Trading Page
    buy: 'Сатып алу',
    sell: 'Сату',
    market: 'Нарықтық',
    limit: 'Лимиттік',
    quantity: 'Саны',
    price: 'Баға',
    total: 'Барлығы',
    openOrders: 'Ашық ордерлер',
    orderHistory: 'Ордер тарихы',
    positions: 'Позициялар',
    orders: 'Ордерлер',
    futures: 'Фьючерстер',
    spot: 'Спот',
    recentTrades: 'Соңғы сауда-саттық',
    indicators: 'Индикаторлар',
    symbol: 'Символ',
    size: 'Көлем',
    entry: 'Кіру',
    liq: 'Лик.',
    actions: 'Әрекеттер',
    openPosition: 'Ашу',
    
    // IDO Page
    participate: 'Қатысу',
    allocation: 'Аллокация',
    tokenPrice: 'Токен бағасы',
    hardCap: 'Hard Cap',
    softCap: 'Soft Cap',
    startDate: 'Басталуы',
    endDate: 'Аяқталуы',
    participants: 'Қатысушылар',
    raised: 'Жиналды',
    remaining: 'Қалды',
    progress: 'Прогресс',
    buyButton: 'Сатып алу',
    sellButton: 'Сату',
    openForBuy: 'Сатып алуға ашық',
    openForSell: 'Сатуға ашық',
    yourBalance: 'Сіздің балансыңыз',
    tokens: 'токен',
    sold: 'Сатылды',
    total: 'Барлығы',
    minPurchase: 'Мин. сатып алу',
    maxPurchase: 'Макс. сатып алу',
    buyPrice: 'Сатып алу бағасы',
    sellPrice: 'Сату бағасы',
    insufficientTokens: 'Токендер жеткіліксіз',
    idoPortfolio: 'IDO Портфолио',
    boughtAt: 'Сатып алынды',
    purchase: 'Сатып алу',
    sale: 'Сату',
    
    // Home Page Extra
    popularMarkets: 'Танымал нарықтар',
    openPositions: 'Ашық позициялар',
    management: 'Басқару',
    all: 'Барлығы',
    noOpenPositions: 'Ашық позициялар жоқ',
    startTrading: 'Сауданы бастау',
    myIdoTokens: 'Менің IDO Токендерім',
    spotPortfolio: 'Spot Портфолио',
    topMarkets: 'Үздік нарықтар',
    growth: 'Өсу',
    decline: 'Төмендеу',
    margin: 'Маржа',
    connectedWalletLabel: 'Қосылған әмиян',
    savedWallet: 'Сақталған әмиян',
    walletNeedsReconnect: 'Транзакциялар үшін қайта қосу қажет',
    reconnect: 'Қайта қосу',
    add: 'Қосу',
    deposits: 'Депозиттер',
    withdrawals: 'Шығарулар',
    noWithdrawalsYet: 'Шығарулар жоқ',
    noDepositsYet: 'Депозиттер жоқ',
    withdrawFunds: 'Қаражатты шығару',
    availableForWithdrawal: 'Шығаруға қолжетімді',
    withdrawalInfo: 'Шығару туралы ақпарат',
    networkFee: 'Желі комиссиясы',
    minWithdrawal: 'Мин. шығару',
    processingTime: 'Өңдеу уақыты',
    hours: 'сағат',
    walletAddress: 'Әмиян мекенжайы',
    enterWalletAddress: 'Әмиян мекенжайын енгізіңіз',
    checkAddress: 'Алушының мекенжайын тексеріңіз. Транзакциялар қайтарылмайды.',
    sendingInProgress: 'Жіберілуде...',
    processingInProgress: 'Өңделуде...',
    confirmDeposit: 'Депозитті растау',
    sendFromWalletButton: 'Әмияннан жіберу',
    availableInWallet: 'Әмиянда қолжетімді',
    notConfigured: 'Конфигурацияланбаған',
    
    // Errors & Validation
    requiredField: 'Міндетті өріс',
    invalidEmail: 'Қате email',
    passwordTooShort: 'Құпия сөз тым қысқа',
    passwordsNotMatch: 'Құпия сөздер сәйкес келмейді',
    insufficientBalance: 'Қаражат жеткіліксіз',
    passwordNotMeetRequirements: 'Құпия сөз талаптарға сай емес',
    pleaseAgreeToTerms: 'Қызмет көрсету шарттарын қабылдаңыз',
    comingSoon: 'Жақында қолжетімді болады',
    registrationComingSoon: '{provider} арқылы тіркелу — жақында!',
    failedToConnectWallet: 'Әмиянды қосу сәтсіз',
    connectWalletFirst: 'Алдымен әмиянды қосыңыз',
    depositAddressNotConfigured: 'Депозит мекенжайы конфигурацияланбаған',
    enterValidAmount: 'Дұрыс соманы енгізіңіз',
    insufficientWalletBalance: 'Әмиянда қаражат жеткіліксіз',
    transactionCancelled: 'Транзакция тоқтатылды',
    transactionFailed: 'Транзакция сәтсіз аяқталды',
    sentSuccessfully: 'Сәтті жіберілді',
    depositRequestCreated: 'Депозит өтініші жасалды',
    failedToCreateDeposit: 'Депозит жасау сәтсіз',
    withdrawalRequestCreated: 'Шығару өтініші жасалды',
    failedToCreateWithdrawal: 'Шығару сәтсіз',
    errorPrefix: 'Қате',
    enterWithdrawalAddress: 'Шығару мекенжайын енгізіңіз',
    
    // Login/Register
    login: 'Кіру',
    register: 'Тіркелу',
    forgotPassword: 'Құпия сөзді ұмыттыңыз ба?',
    noAccount: 'Аккаунт жоқ па?',
    haveAccount: 'Аккаунт бар ма?',
    signUp: 'Тіркелу',
    signIn: 'Кіру',
    welcomeBack: 'Қош келдіңіз',
    signInToContinue: 'Жалғастыру үшін аккаунтқа кіріңіз',
    emailAddress: 'Email адресі',
    enterEmail: 'Email енгізіңіз',
    password: 'Құпия сөз',
    enterPassword: 'Құпия сөзді енгізіңіз',
    orContinueWith: 'Немесе жалғастыру',
    termsAgreement: 'Жалғастыра отырып, сіз ExDex Қызмет көрсету шарттары мен Құпиялылық саясатына келісесіз',
    createAccount: 'Аккаунт жасау',
    startJourney: 'Бүгін крипто-саяхатыңызды бастаңыз',
    confirmYourPassword: 'Құпия сөзді растаңыз',
    passwordRequirements: 'Құпия сөз талаптары',
    minChars: 'Кемінде 6 таңба',
    hasNumber: 'Сан бар',
    hasLetter: 'Әріп бар',
    agreeToTerms: 'Мен келісемін',
    termsOfService: 'Қызмет көрсету шарттары',
    and: 'және',
    privacyPolicy: 'Құпиялылық саясаты',
    twoFactorAuth: 'Екі факторлы аутентификация',
    enterAuthenticatorCode: 'Google Authenticator кодын енгізіңіз',
    enterEmailCode: 'Email-ге жіберілген кодты енгізіңіз',
    enterBothCodes: 'Растау үшін екі кодты да енгізіңіз',
    verifying: 'Тексерілуде...',
    invalidCode: 'Қате код',
    sendCode: 'Код жіберу',
    codeSent: 'Код жіберілді',
    authenticatorCode: 'Аутентификатор коды',
    emailVerificationCode: 'Email растау коды',
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('exdex_language');
    return saved || 'ru';
  });

  useEffect(() => {
    localStorage.setItem('exdex_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, LANGUAGES, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
